export default function getEmptyMouvementClient() {
  return {
    id: null,
    dateMouvement: null,
    credit: null,
    remiseBancaireId: '',
    tiersId: '',
    resteALettrer: 0.0,
    factureId: '',
    libelle: '',
    brouillard: false,
    moveReglementId: '',
    bonAPayer: false,
    ligneRemiseBancairePseudoEntity: {
      emetteur: '',
      referenceReglement: '',
      dateEffet: null,
    },
    lettrages: [],
  };
}
